(function ($) {

	function update_cart_item() {

		let data = JSON.parse($(this).attr('data-restock-reminder-update'))

		gp_ajax({
			url: ghostpress_params.ajax_url + "&action=restock_reminder_update",
			type: "post",
			dataType: "json",
			data: data,
			show_loading: true
		})
	}

	function init_cart_items() {
		// Update restock reminder
		$('[data-restock-reminder-update]').gp_on('click', update_cart_item)
	}

	// Init cart functions
	$(document).gp_ready(init_cart_items)

})(jQuery);
